import util from '@bmp-vue/core/api/util'

const controller = 'OcorrenciaDez'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'get', 'put', 'delete']), {
    GetRelatorioOcorrenciaDezPorData(dto){
        return util.Axios.GetAll(`${controller}/GetRelatorioOcorrenciaDezPorData`, dto)
    }
})
